export default __webpack_public_path__ + "static/media/ad_interstitial.8aa99a24.png";